<template>
    <!--<div class="col-lg-3 other-techs">
        <div class="card">
            <div class="card-header">
                {{ header }}
            </div>
            <div class="card-body">
                <p class="card-text">
                    <slot name="svg"></slot>
                </p>
            </div>
            <div class="card-footer">
                <strong>{{ footer }}</strong>
            </div>
        </div>
    </div>-->
    <div class="col-lg-2 other-techs" style="margin-bottom: 30px;" align="center">
        <div v-tooltip.top-center="'<strong>' + footer + '</strong><br>' + header">
            <slot name="svg"></slot>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['header', 'footer', 'svg']
    }
</script>



// WEBPACK FOOTER //
// other-tech.vue?7285d8aa